export const ELIGIBILITY_QUESTIONS = {
    otherCoverage:
        'Will you have other prescription drug coverage (like VA, TRICARE) in addition to Alignment Health Plan?',
    chronicCondition:
        'Do you have a chronic condition that qualifies you for a special needs plan?',
    enrolledStateMedicaid:
        'Are you eligible for or currently enrolled in State Medicaid or Medi-Cal?',
};
